const ASSISTANT_AUTO_OPEN_STORAGE_KEY = "assistant-auto-open-after-login";

const isMobileViewport = (): boolean =>
  typeof window !== "undefined" &&
  window.matchMedia(
    "(max-width: 768px), (hover: none) and (pointer: coarse)"
  ).matches;

export const requestAssistantAutoOpen = () => {
  try {
    sessionStorage.setItem(ASSISTANT_AUTO_OPEN_STORAGE_KEY, "true");
  } catch {
    // Storage may be unavailable in restricted browser environments.
  }
};

export const consumeAssistantAutoOpen = (): boolean => {
  try {
    const shouldOpen =
      sessionStorage.getItem(ASSISTANT_AUTO_OPEN_STORAGE_KEY) === "true";
    sessionStorage.removeItem(ASSISTANT_AUTO_OPEN_STORAGE_KEY);
    return shouldOpen && !isMobileViewport();
  } catch {
    return false;
  }
};
